import {
  COLOR_MODE,
  DataMessage,
  ImageAutoleveler,
  ImageNoiseSuppressor,
  ImageScaler,
} from '@ouster/webviz';
import { ImageSettings } from '@ouster/webviz-react-components';

export type PerImageProcessors = {
  imageSuppressor: ImageNoiseSuppressor;
  imageAutoLeveler: ImageAutoleveler;
  imageScaler: ImageScaler;
};

type ApplyPerImageTransformsArgs = {
  msg: DataMessage;
  imageSettings: Pick<
    ImageSettings,
    'coloringMode' | 'isAutoLevelsOn' | 'isNoiseSuppressionOn'
  >;
  rgbChannels: string[];
  processors: PerImageProcessors;
};

export const applyPerImageTransforms = ({
  msg,
  imageSettings,
  rgbChannels,
  processors,
}: ApplyPerImageTransformsArgs): DataMessage => {
  const { imageSuppressor, imageAutoLeveler, imageScaler } = processors;
  const { coloringMode, isAutoLevelsOn, isNoiseSuppressionOn } = imageSettings;
  const isRgbMode =
    rgbChannels.length > 0 && rgbChannels.includes(coloringMode);
  const shouldAutoLevel = isAutoLevelsOn && !isRgbMode;
  const shouldScale =
    !shouldAutoLevel &&
    !isRgbMode &&
    !coloringMode.startsWith(COLOR_MODE.REFLECTIVITY);

  imageSuppressor.channelFields = isNoiseSuppressionOn ? [coloringMode] : [];
  imageAutoLeveler.channelFields = shouldAutoLevel ? [coloringMode] : [];
  imageScaler.channelFields = shouldScale ? [coloringMode] : [];

  return imageScaler.mapImage(
    imageAutoLeveler.mapImage(imageSuppressor.mapImage(msg))
  );
};
